// Shared multi-column sort utility, used by both PropertiesTable and the
// export pipeline so the exported report matches exactly what the user sees.

export const NUMERIC_FIELDS = new Set(["mq", "prezzo", "eur_mq", "scostamento"]);

const getVal = (row, key) => {
  if (key === "venditore") {
    return row.tipo_venditore === "PRIVATO" ? "Privato" : (row.agenzia_nome || "Agenzia");
  }
  return row[key];
};

export const sortRows = (rows, config) => {
  if (!config || config.length === 0) return rows;
  const arr = [...rows];
  arr.sort((a, b) => {
    for (const { key, direction } of config) {
      const dir = direction === "asc" ? 1 : -1;
      const va = getVal(a, key);
      const vb = getVal(b, key);
      const aNil = va === null || va === undefined || va === "";
      const bNil = vb === null || vb === undefined || vb === "";
      if (aNil && bNil) continue;
      if (aNil) return 1;
      if (bNil) return -1;
      let cmp;
      if (typeof va === "string" && typeof vb === "string") {
        cmp = va.localeCompare(vb, "it", { sensitivity: "base" });
      } else if (typeof va === "boolean" || typeof vb === "boolean") {
        cmp = (va === vb) ? 0 : va ? -1 : 1;
      } else {
        cmp = va < vb ? -1 : va > vb ? 1 : 0;
      }
      if (cmp !== 0) return dir * cmp;
    }
    return 0;
  });
  return arr;
};
